import { Select, TextInput } from "@msuite/ui/form";
import { useTranslation } from "@msuite/ui/localization";
import { getAttendanceWorksiteTranslationKey, worksites } from "@msuite/utils/attendances";
import type { AcknowledgementDefinitionFormSchema } from "@msuite/utils/schemas";
import { useFormContext } from "react-hook-form";

/** Props Interface */
interface AcknowledgementDefinitionFormProps {
	showWorksiteField?: boolean;
}

export function AcknowledgementDefinitionForm({
	showWorksiteField,
}: AcknowledgementDefinitionFormProps) {
	/** Hooks */
	const { t } = useTranslation();
	const methods = useFormContext<AcknowledgementDefinitionFormSchema>();

	/** Render */
	return (
		<div className="v-stack gap-4">
			<TextInput
				control={methods.control}
				name="text"
				label={t("general.text")}
				isRequired
				placeholder={t("placeholders.text")}
			/>
			<Select
				control={methods.control}
				name="state"
				label={t("general.state")}
				isRequired
				isNullable={false}
				itemNotFoundLabel="Not Found"
				options={[
					{ label: t("general.active"), value: "active", item: {} },
					{ label: t("general.inactive"), value: "inactive", item: {} },
				]}
			/>
			{showWorksiteField && (
				<Select
					control={methods.control}
					name="worksite"
					label={t("users.worksite")}
					isRequired
					isNullable={false}
					itemNotFoundLabel="Not Found"
					options={worksites.map((w) => ({
						label: t(getAttendanceWorksiteTranslationKey(w)),
						value: w,
						item: {},
					}))}
				/>
			)}
		</div>
	);
}
